/* eslint-disable i18next/no-literal-string */
import { useSyncExternalStore } from 'react';
import DetailItem from '@/features/diagnostics/components/lib/detail-item.tsx';
import { DiagnosticsList } from '@/features/diagnostics/components/lib/diagnostics.tsx';
import DiagnosticsStore from '@/features/diagnostics/store/diagnostics-store.ts';
import { DiagnosticsEmpty } from '../lib/diagnostics-card.tsx';










export default function HistoryStateList() {
    const historyState = useSyncExternalStore(DiagnosticsStore.subscribe, () => DiagnosticsStore.historyState);

    if (historyState.length === 0) {
        return <DiagnosticsEmpty>No history state present yet!</DiagnosticsEmpty>;
    }

    return (
        <DiagnosticsList>
            {historyState.map((entry) => (
                <DetailItem
                    key={entry.id}
                    timestamp={entry.timestamp}
                    name={entry.smartNumber}
                    data={entry.smartNumberMapping}
                />
            ))}
        </DiagnosticsList>
    );
}
